import { get } from "./config";
import { getApiUrl } from "./api-config";
import { toAnalyticsUtcPeriod } from "../utils/analyticsPeriod";

const endpoints = {
  summary: "",
  dynamics: "/dinamics",
  assignment: "/tender-or-direct",
  carriers: "/carrier-statistics",
  directions: "/directions",
  tenders: "/tenders",
};

export async function getOrderAnalytics(section, { startDate, endDate, mode = "all", signal }) {
  if (!Object.prototype.hasOwnProperty.call(endpoints, section)) {
    throw new Error("Unknown analytics section");
  }
  if (!["all", "auto", "air"].includes(mode)) {
    throw new Error("Unknown analytics mode");
  }
  const { data } = await get(`OrderAnalytics${endpoints[section]}`, {
    baseURL: getApiUrl("analytics/api/"),
    params: { ...toAnalyticsUtcPeriod({ startDate, endDate }), mode },
    signal,
    timeout: 30000,
  });
  const isObject = data !== null && typeof data === "object" && !Array.isArray(data);
  if (section === "carriers" ? !Array.isArray(data) : !isObject) {
    throw new Error("Invalid analytics response");
  }
  return data;
}
